import { styled } from '@mui/material/styles';
import { FormattedMessage } from 'react-intl';

export type FileStatusBadgeState =
  | 'Ready'
  | 'Duplicate'
  | 'Waiting'
  | 'ActionNeeded';

export type FileStatusBadgeProps = {
  state: FileStatusBadgeState;
};

const FileStatusBadge = ({ state }: FileStatusBadgeProps) => {
  return (
    <BadgeRoot $state={state}>
      {state === 'Ready' ? (
        <FormattedMessage
          id="complianceDocumentsUploadModal.fileStatus.ready"
          defaultMessage="Ready"
        />
      ) : state === 'Duplicate' ? (
        <FormattedMessage
          id="complianceDocumentsUploadModal.fileStatus.duplicate"
          defaultMessage="Duplicate"
        />
      ) : state === 'ActionNeeded' ? (
        <FormattedMessage
          id="complianceDocumentsUploadModal.fileStatus.actionNeeded"
          defaultMessage="Action needed"
        />
      ) : (
        <FormattedMessage
          id="fileStatusBadge.waitingForFileType"
          defaultMessage="Waiting for File Type"
        />
      )}
    </BadgeRoot>
  );
};

const BadgeRoot = styled('div')<{
  $state: FileStatusBadgeState;
}>(({ theme, $state }) => ({
  boxSizing: 'border-box',
  minWidth: 75,
  width: $state === 'Waiting' || $state === 'ActionNeeded' ? 'auto' : 75,
  height: 20,
  padding: $state === 'Waiting' || $state === 'ActionNeeded' ? '0 8px' : 0,
  flexShrink: 0,
  alignSelf: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  whiteSpace: 'nowrap',
  borderRadius: theme.radii.md,
  fontSize: '10px',
  fontWeight: 600,
  lineHeight: 1,
  ...($state === 'Ready'
    ? {
        backgroundColor: theme.palette.green50,
        border: `2px solid ${theme.palette.green400}`,
        color: theme.palette.green400,
      }
    : $state === 'Duplicate'
      ? {
          backgroundColor: theme.palette.yellow50,
          border: `2px solid ${theme.palette.yellow500}`,
          color: theme.palette.yellow500,
        }
      : $state === 'ActionNeeded'
        ? {
            backgroundColor: theme.palette.red50,
            border: `2px solid ${theme.palette.red400}`,
            color: theme.palette.red400,
          }
        : {
            backgroundColor: theme.palette.grey50,
            border: `2px solid ${theme.palette.grey400}`,
            color: theme.palette.grey500,
          }),
}));

export default FileStatusBadge;
